export const tAndCLink = "https://planetpatrol.co/terms-conditions/";
export const privacyPolicyLink =
  "https://planetpatrol.co/data-protection-notice/";

export const feedbackEmail = "hello@planetpatrol.co";

export const tweetMessage =
  "Check out this rubbish shared on the @Planet_Patrol app for global citizen science. Researchers analyse everything collected and use it as evidence to help tackle the problem. #PlanetPatrol";
